var css = {"emblaCarousel":"Carousel-module_emblaCarousel__4Myp9"};

export { css as default };
